import BaseModel from './BaseModel';
import Point from './Point';

export default class DeploymentOffset extends BaseModel {
  static fields = [
    { key: 'deployment', type: 'string' },
    { key: 'offset', type: Point },
  ];
}
